module.exports = __webpack_public_path__ + "static/004.thumb-4c954d46f8257b40e62deef55261309a.jpg";